import { cloneElement, useRef, useState, type ReactElement, type RefAttributes, type SyntheticEvent } from 'react';
import { Tooltip } from 'framework/ui/mui-builder';

interface OverflowTooltipProps {
  children: ReactElement<RefAttributes<HTMLElement>>;
}

const isTruncated = (element: HTMLElement) =>
  [element, ...element.querySelectorAll<HTMLElement>('*')].some(node => node.scrollWidth > node.clientWidth);

const OverflowTooltip = ({ children }: OverflowTooltipProps) => {
  const ref = useRef<HTMLElement>(null);
  const [title, setTitle] = useState<string | null>(null);

  const handleOpen = (event: SyntheticEvent) => {
    const element = ref.current;
    if (event.target instanceof Element && event.target.closest('svg')) return;
    if (element && isTruncated(element)) setTitle(element.textContent);
  };

  return (
    <Tooltip title={title ?? ''} open={Boolean(title)} onOpen={handleOpen} onClose={() => setTitle(null)}>
      {cloneElement(children, { ref })}
    </Tooltip>
  );
};

export default OverflowTooltip;
